<script>
import appConfig from '@src/app.config'
import { authComputed, authMethods } from '@state/helpers'
export default {
  name: 'LeftMenu',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      leftMenuExpand: false,
      openedHubs: false,
      openedGroups: false,
      openedOpenGroups: false,
      openedAdminHubs: false,
    }
  },
  computed: {
    ...authComputed,
    currentCompanyId() {
      const routeCompanyId = parseInt(this.$route.params.companyId, 10)
      if (routeCompanyId) {
        return routeCompanyId
      }
      const lastVisitedCompanyId = localStorage.getItem(
        'LAST_VISITED_COMPANY_ID'
      )
      if (lastVisitedCompanyId) {
        return +lastVisitedCompanyId
      }
      if (this.currentUser && this.currentUser.default_company_id) {
        return +this.currentUser.default_company_id
      }
      return +appConfig.kyndhub_id
    },
  },
  methods: {
    ...authMethods,
    toggleHubs: function() {
      this.openedHubs = !this.openedHubs
    },
    toggleGroups: function() {
      this.openedGroups = !this.openedGroups
    },
    toggleOpenGroups: function() {
      this.openedOpenGroups = !this.openedOpenGroups
    },
    currentCompany() {
      const currentCompany = this.currentUser.companies.find(
        (company) => company.id === this.currentCompanyId
      )
      return currentCompany
    },
    toggleOpenAdminHubs: function() {
      this.openedAdminHubs = !this.openedAdminHubs
    },
    companyHasStore() {
      return (
        (this.currentCompany().store_status !== '' ||
          this.canEditCompany(this.currentCompany())) &&
        this.currentCompany().name !== 'My Hub'
      )
    },
    mouseoverEvent() {
      if (this.leftMenuExpand) {
        return
      }
      this.leftMenuExpand = true
    },
    mouseleaveEvent() {
      this.leftMenuExpand = false
    },
  },
}
</script>

<template>
  <div
    id="leftMenu"
    class="leftMenuBox mt-28"
    :class="leftMenuExpand && 'w-70'"
    @mouseover="mouseoverEvent"
    @mouseleave="mouseleaveEvent"
  >
    <ul class="py-6 absolute inset-y-0 overflow-y-scroll">
      <li v-if="currentUser.default_company_id">
        <div>
          <router-link
            :to="{
              name: 'company',
              params: { companyId: currentUser.default_company_id },
            }"
          >
            <svg
              id="Layer_1"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 1000 1000"
              style="enable-background:new 0 0 1000 1000;"
              xml:space="preserve"
              height="24"
            >
              <path
                fill="#069BD7"
                d="M993.52,448.66L515.74,26.44c-8.44-7.44-21-7.44-29.44,0L8.52,448.66c-4.67,4.22-7.44,10.33-7.44,16.67v44.44
	C1.08,522,11.08,532,23.3,532h66.67v422.22c0,12.22,10,22.22,22.22,22.22h300c12.22,0,22.22-10,22.22-22.22v-200
	c0-36.78,29.89-66.67,66.67-66.67s66.67,29.89,66.67,66.67v200c0,12.22,10,22.22,22.22,22.22h300c12.22,0,22.22-10,22.22-22.22V532
	h66.67c12.22,0,22.22-10,22.22-22.22v-44.44C1001.08,459,998.3,452.88,993.52,448.66z M956.63,487.55h-66.67
	c-12.22,0-22.22,10-22.22,22.22V932H612.19V754.22c0-61.22-49.89-111.11-111.11-111.11S389.97,693,389.97,754.22V932H134.41V509.77
	c0-12.22-10-22.22-22.22-22.22H45.52v-12.22L501.08,72.77l455.56,402.56V487.55z"
              />
            </svg> </router-link
          ><span>
            <router-link
              :to="{
                name: 'company',
                params: { companyId: currentUser.default_company_id },
              }"
              >Home</router-link
            >
          </span>
        </div>
      </li>
      <li>
        <div>
          <a @click="toggleHubs">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1000 981.46"
              height="24"
              fill="#069BD7"
            >
              <title>Kyndhub_Hubs_Icon</title>
              <path
                d="M979.53,132.29a75.57,75.57,0,0,0-54-26.42,78.93,78.93,0,0,0-83.94,72h0A64.07,64.07,0,0,0,844,204.35L599.05,346a153.26,153.26,0,0,0-32.4-30,132.48,132.48,0,0,0-60-22.81V163.67a78.58,78.58,0,1,0-65.19-10.91h0a86.82,86.82,0,0,0,24,10.82V293.24A140.87,140.87,0,0,0,373,346.08L154.71,220a78.4,78.4,0,0,0-6-49.15,79.77,79.77,0,0,0-44.48-39.7,75,75,0,0,0-60,3.61,79.8,79.8,0,0,0-39.57,44.4,75,75,0,0,0,3.61,60,79.82,79.82,0,0,0,44.4,39.62,93.61,93.61,0,0,0,25.24,4.79,66.57,66.57,0,0,0,33.63-8.4,100,100,0,0,0,25.19-19.21l217.4,124.86a131.43,131.43,0,0,0-7.21,80.45,170.17,170.17,0,0,0,7.21,26.43L229.14,559.71A79,79,0,0,0,94.65,608.87a77.84,77.84,0,0,0,72.54,82.79l.71,0h5.94a80.67,80.67,0,0,0,51.61-19.21A75.6,75.6,0,0,0,252,618.37h0A66.13,66.13,0,0,0,249.54,592l125-71.89a153.06,153.06,0,0,0,32.41,30,135.81,135.81,0,0,0,60,22.81V837a78.17,78.17,0,0,0-44.41,31.22,80,80,0,0,0,20.49,109.25,74.23,74.23,0,0,0,44.4,13.19,76.33,76.33,0,0,0,64.85-34.82,80,80,0,0,0-20.48-109.25h0a86.88,86.88,0,0,0-24-10.82V571.72c2.42,0,4.79-1.19,7.21-1.19a144.33,144.33,0,0,0,85.25-51.62l162.09,93.65a77.84,77.84,0,0,0,49.16,94.83,93.33,93.33,0,0,0,25.19,4.79,66.7,66.7,0,0,0,33.64-8.39A79.86,79.86,0,0,0,910,659.38a75,75,0,0,0-3.61-60A79.82,79.82,0,0,0,862,559.75a75,75,0,0,0-60,3.61A71.08,71.08,0,0,0,780.32,579l-161-91.27a131.46,131.46,0,0,0,7.21-80.46,170.35,170.35,0,0,0-7.21-26.42L865.48,239.17A76,76,0,0,0,915.91,262h6a77.83,77.83,0,0,0,78-73.24A81.94,81.94,0,0,0,979.53,132.29ZM94.69,239.12A34.52,34.52,0,0,1,66,240.31,33.38,33.38,0,0,1,43,221a34.58,34.58,0,0,1-1.19-28.68,37.16,37.16,0,0,1,36-25.19,35.25,35.25,0,0,1,12,2.42,38.19,38.19,0,0,1,21.63,19.21,36.86,36.86,0,0,1-15.55,49.76c-.41.22-.83.43-1.25.63ZM211.16,617.31h0A42.93,42.93,0,0,1,198,643.73a38.94,38.94,0,0,1-27.61,9.59,43,43,0,0,1-26.42-13.19,39,39,0,0,1-9.58-27.61,38.22,38.22,0,0,1,38.42-36h2.42a42.92,42.92,0,0,1,26.42,13.19,35.73,35.73,0,0,1,9.55,27.65ZM454.85,66.25a38.84,38.84,0,1,1-.18.27ZM518.51,937.9a38.14,38.14,0,0,1-63.62-42,35.66,35.66,0,0,1,24-15.61c2.42,0,4.79-1.19,7.21-1.19a36.05,36.05,0,0,1,21.63,7.21h0a35.64,35.64,0,0,1,12.62,48.8C519.79,936.05,519.17,937,518.51,937.9ZM505.32,535.67a102.8,102.8,0,0,1-76.85-15.61,100.06,100.06,0,0,1-43.26-66,102.83,102.83,0,0,1,15.61-76.85,106.08,106.08,0,0,1,85.25-45.6,102.08,102.08,0,0,1,57.64,18,100,100,0,0,1,43.21,66,102.79,102.79,0,0,1-15.6,76.85,109.45,109.45,0,0,1-66,43.18Zm314.57,66a38.31,38.31,0,0,1,16.79-3.6,35.54,35.54,0,0,1,12,2.41,38.18,38.18,0,0,1,21.63,19.22,34.56,34.56,0,0,1,1.18,28.67A38.19,38.19,0,0,1,852.29,670a34.56,34.56,0,0,1-28.67,1.19A38.13,38.13,0,0,1,802,652a34.58,34.58,0,0,1-1.19-28.68,37.74,37.74,0,0,1,19.05-21.59ZM959.17,186.28a38.51,38.51,0,1,1-76.94-3.3c0-.5,0-1,.09-1.49h0a38.71,38.71,0,0,1,41-36,43,43,0,0,1,26.43,13.19,32.77,32.77,0,0,1,9.42,27.65Z"
                transform="translate(0 -9.27)"
              />
            </svg> </a
          ><span>
            <a @click="toggleHubs">Hubs</a>
            <a @click="toggleHubs">
              <svg
                viewBox="0 0 140 140"
                width="15"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path
                    d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                    fill="#069BD7"
                  />
                </g>
              </svg>
            </a>
          </span>
        </div>
        <ul :class="[leftMenuExpand && openedHubs ? 'block' : 'hidden']">
          <li v-for="company in user.companies" :key="company.id">
            <router-link
              :to="{ name: 'company', params: { companyId: company.id } }"
              class="pl-29 w-full inline-block"
              >{{ company.name }}</router-link
            >
          </li>
        </ul>
      </li>
      <li>
        <div>
          <a @click="toggleGroups">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 896.11 1000"
              height="24"
              fill="#069BD7"
            >
              <title>Kyndhub_Groups_Icon</title>
              <path
                d="M857.9,580l-5.49-1.27V421.27l5.53-1.23a114.68,114.68,0,0,0,90.11-112.48,116.12,116.12,0,0,0-201.2-79.43l-3.85,4.1L609.58,155.14l1.31-5.2a145.3,145.3,0,0,0,5.41-33.39,116.5,116.5,0,0,0-233-.11v.11a89.39,89.39,0,0,0,5.16,32.77l2.09,5.61-133.5,77.34-3.85-4.1A116,116,0,1,0,142,420l5.49,1.27V578.69L142,580A116,116,0,1,0,253.21,771.83l3.85-4.1,133.09,77.13-1.31,5.2a145.3,145.3,0,0,0-5.41,33.39,116.5,116.5,0,0,0,233,.11v-.11a89.39,89.39,0,0,0-5.16-32.77l-2.09-5.61,133.66-77.46,3.85,4.09A116,116,0,1,0,857.9,579.84ZM832.83,231.78a74.59,74.59,0,0,1,74.51,74.51v.16a75.59,75.59,0,0,1-74.51,74.23,74.51,74.51,0,0,1,0-149ZM501.36,43.43a74.51,74.51,0,0,1,0,149,73.72,73.72,0,0,1-74.51-72.94c0-.52,0-1,0-1.57A74.59,74.59,0,0,1,501.36,43.43ZM96.77,307.56a74.51,74.51,0,1,1,74.51,74.55H171A75.58,75.58,0,0,1,96.77,307.56Zm73.12,459.35a74.51,74.51,0,1,1,74.51-74.59,74.51,74.51,0,0,1-74.51,74.59h0ZM501.36,956.53a74.52,74.52,0,0,1,0-149,73.73,73.73,0,0,1,74.51,73c0,.52,0,1,0,1.57a74.6,74.6,0,0,1-74.51,74.55Zm215-264.21a82.16,82.16,0,0,0,5,30.93l2.5,5.77-134,77.71-3.85-4.1a115.31,115.31,0,0,0-162.94-6.52q-3.39,3.14-6.52,6.52l-3.85,4.1L279.67,729.59l1.31-5.16a134.55,134.55,0,0,0,5.41-32A116.61,116.61,0,0,0,196.27,580l-5.49-1.27V421.31l5.49-1.27a116.61,116.61,0,0,0,90.12-112.48,82.13,82.13,0,0,0-5-30.93l-2.5-5.77L413,193.27l3.85,4.1a115.31,115.31,0,0,0,162.94,6.52q3.39-3.13,6.52-6.52l3.86-4.1L723,270.41l-1.31,5.16a134.55,134.55,0,0,0-5.41,32A116.61,116.61,0,0,0,806.41,420l5.49,1.27V578.69L806.41,580A116.62,116.62,0,0,0,716.33,692.32Zm115.1,74.51a74.51,74.51,0,1,1,0-149h.25A75.57,75.57,0,0,1,906,692.32,74.6,74.6,0,0,1,831.43,767Z"
                transform="translate(-51.94 0)"
              />
            </svg> </a
          ><span>
            <a @click="toggleGroups">Groups</a>
            <a @click="toggleGroups">
              <svg
                viewBox="0 0 140 140"
                width="15"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path
                    d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                    fill="#069BD7"
                  />
                </g>
              </svg>
            </a>
          </span>
        </div>
        <ul :class="[leftMenuExpand && openedGroups ? 'block' : 'hidden']">
          <li v-for="group in currentCompany().groups" :key="group.id">
            <router-link
              :to="{
                name: 'group',
                params: { companyId: group.company_id, groupId: group.id },
              }"
              class="pl-29 w-full inline-block"
              >{{ group.name }}</router-link
            >
          </li>
        </ul>
      </li>
      <li>
        <div>
          <a @click="toggleOpenGroups">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 21.905 24.386"
              height="24"
              fill="#069BD7"
            >
              <path
                id="Path_9"
                data-name="Path 9"
                d="M193.618.25a2.868,2.868,0,1,0,2.868,2.868A2.868,2.868,0,0,0,193.618.25Zm.024,4.662a1.806,1.806,0,1,1,1.806-1.806A1.806,1.806,0,0,1,193.643,4.912Z"
                transform="translate(-182.69 -0.25)"
                fill="#069bd7"
              />
              <path
                id="Path_10"
                data-name="Path 10"
                d="M193.618,382.25a2.868,2.868,0,1,0,2.868,2.868A2.868,2.868,0,0,0,193.618,382.25Zm.024,4.662a1.806,1.806,0,1,1,1.806-1.806A1.806,1.806,0,0,1,193.643,386.912Z"
                transform="translate(-182.69 -363.601)"
                fill="#069bd7"
              />
              <path
                id="Path_11"
                data-name="Path 11"
                d="M361.173,96.6a2.868,2.868,0,1,0-1.036,3.922A2.868,2.868,0,0,0,361.173,96.6Zm-4.017,2.366a1.806,1.806,0,1,1,2.47.653A1.806,1.806,0,0,1,357.156,98.971Z"
                transform="translate(-339.706 -90.544)"
                fill="#069bd7"
              />
              <path
                id="Path_12"
                data-name="Path 12"
                d="M31,288.728a2.868,2.868,0,1,0-1.037,3.922A2.868,2.868,0,0,0,31,288.728Zm-4.018,2.366a1.806,1.806,0,1,1,2.47.653A1.806,1.806,0,0,1,26.985,291.094Z"
                transform="translate(-25.655 -273.288)"
                fill="#069bd7"
              />
              <path
                id="Path_13"
                data-name="Path 13"
                d="M28.081,100.526A2.868,2.868,0,1,0,27.045,96.6,2.868,2.868,0,0,0,28.081,100.526Zm.511-.9a1.806,1.806,0,1,1,2.47-.653A1.806,1.806,0,0,1,28.593,99.624Z"
                transform="translate(-26.606 -90.544)"
                fill="#069bd7"
              />
              <path
                id="Path_14"
                data-name="Path 14"
                d="M358.252,292.65a2.868,2.868,0,1,0-1.036-3.922A2.868,2.868,0,0,0,358.252,292.65Zm.511-.9a1.806,1.806,0,1,1,2.47-.653A1.806,1.806,0,0,1,358.763,291.747Z"
                transform="translate(-340.658 -273.288)"
                fill="#069bd7"
              />
            </svg> </a
          ><span>
            <a @click="toggleOpenGroups">Open Groups</a>
            <a @click="toggleOpenGroups">
              <svg
                viewBox="0 0 140 140"
                width="15"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path
                    d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                    fill="#069BD7"
                  />
                </g>
              </svg>
            </a>
          </span>
        </div>
        <ul :class="[leftMenuExpand && openedOpenGroups ? 'block' : 'hidden']">
          <li v-for="group in user.open_groups" :key="group.id">
            <router-link
              :to="{
                name: 'group',
                params: { companyId: group.company_id, groupId: group.id },
              }"
              class="pl-29 w-full inline-block"
              >{{ group.name }}</router-link
            >
          </li>
        </ul>
      </li>
      <li>
        <div>
          <router-link
            :to="{ name: 'user-page', params: { userId: currentUser.id } }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 887.55 1000"
              height="24"
              fill="#069BD7"
            >
              <title>Kyndhub_MyKyndfulness_Icon</title>
              <path
                d="M937.56,537.13a239.19,239.19,0,0,0-265.45-39.2,244.12,244.12,0,0,0-124,185.63v1A364.75,364.75,0,0,0,519.41,720l.41-280.73a1131.44,1131.44,0,0,0,119.36-84c84.41-72.57,127.25-140.73,127.25-202.54A152.86,152.86,0,0,0,615.17,0a150.83,150.83,0,0,0-66.1,16.38,156,156,0,0,0-48.13,36A151.17,151.17,0,0,0,235.37,152.77a236.29,236.29,0,0,0,76.14,153.72l26,26.13c8.19,7.58,16.38,15.2,25.1,22.61a1104.56,1104.56,0,0,0,119.4,84l-.62,422.24A362.53,362.53,0,0,0,451.83,824v-1.27A244.07,244.07,0,0,0,327.89,637.11a239.26,239.26,0,0,0-265.45,39.2,18.85,18.85,0,0,0,2.74,30c27.49,16.95,54.6,35.47,80.53,55,29.2,22,50.3,40.42,67.25,55.21a198.18,198.18,0,0,0,84.25,53,144.16,144.16,0,0,0,35.64,4.38,211,211,0,0,0,91.91-23.84A294,294,0,0,1,481.44,942v39.12a18.84,18.84,0,0,0,18.8,18.84h0a18.85,18.85,0,0,0,18.85-18.8V946.14a18.76,18.76,0,0,0,0-10.4V800.57a264.76,264.76,0,0,1,55.74-89.45A211.13,211.13,0,0,0,667,735a144.14,144.14,0,0,0,35.63-4.38A198,198,0,0,0,787,677.45c17-14.78,38.05-33.17,67.25-55.21,26-19.62,53.25-38.13,80.52-55A18.83,18.83,0,0,0,941,541.27a19.17,19.17,0,0,0-3.41-4.1ZM306.47,833.05a167.24,167.24,0,0,1-68.69-44.85c-17.4-15.15-39-34-69.3-56.89-19.78-14.95-40.22-29.28-61-42.8A200,200,0,0,1,311,670.74a189.35,189.35,0,0,1,91.74,107.18,357.89,357.89,0,0,0-144.17-66.76A18.84,18.84,0,0,0,250.73,748a318.8,318.8,0,0,1,145.73,73.73A140.74,140.74,0,0,1,306.47,833.05Zm57.34-527.42L338.7,280.36a201.2,201.2,0,0,1-65.53-127.67A113.58,113.58,0,0,1,484.76,93.84a18.84,18.84,0,0,0,32.44,0c1.07-1.85,2.21-3.65,3.4-5.41a113.72,113.72,0,0,1,45.06-38.26A113.33,113.33,0,0,1,614.6,37.68h.45a115.09,115.09,0,0,1,113.82,115c0,50.34-38.41,108.87-114.15,174A1097.71,1097.71,0,0,1,501,406.59a1075,1075,0,0,1-113.7-79.91c-8.19-7.2-16.18-14.25-23.39-21ZM831.48,592.34c-30.27,22.86-51.9,41.74-69.31,56.89a167,167,0,0,1-68.72,44.85,140.85,140.85,0,0,1-90.11-11.38A318.65,318.65,0,0,1,749.07,609a18.85,18.85,0,1,0-7.87-36.86A357.63,357.63,0,0,0,597,638.87a189.34,189.34,0,0,1,91.75-107.15A199.92,199.92,0,0,1,892.3,549.5c-20.48,13.39-40.92,27.73-60.62,42.68Z"
                transform="translate(-56.23)"
              />
              <path
                d="M676,151.46a18.76,18.76,0,0,0,13.27-32.11,19.64,19.64,0,0,0-26.67,0A18.8,18.8,0,0,0,676,151.46Z"
                transform="translate(-56.23)"
              />
              <path
                d="M550.5,317.31a18.79,18.79,0,0,0,12.29-4.55A464.85,464.85,0,0,0,663.26,199.1a18.91,18.91,0,1,0-32.77-18.88,428.74,428.74,0,0,1-92.44,104,18.84,18.84,0,0,0,12.29,33.1Z"
                transform="translate(-56.23)"
              />
            </svg> </router-link
          ><span>
            <router-link
              :to="{ name: 'user-page', params: { userId: currentUser.id } }"
              >My Kyndfulness</router-link
            >
          </span>
        </div>
      </li>
      <li>
        <div>
          <router-link
            :to="{
              name: 'companyEvents',
              params: { companyId: currentCompanyId },
            }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1000 957.8"
              height="24"
              fill="#069BD7"
            >
              <title>Kyndhub_Events_Icon</title>
              <path
                d="M975.44,151.77H783.87V46.68a24.56,24.56,0,0,0-49.08,0V151.82H265.21V46.68a24.56,24.56,0,0,0-49.08-2q0,1,0,2V151.82H24.56A24.56,24.56,0,0,0,0,176.34v778A24.56,24.56,0,0,0,24.56,978.9H975.44A24.56,24.56,0,0,0,1000,954.34h0v-778a24.57,24.57,0,0,0-24.56-24.57Zm-24.56,778H49.08V460.2h901.8Zm0-518.66H49.08V200.9h167v61.87a24.56,24.56,0,0,0,49.08,0V200.9H734.74v61.87a24.57,24.57,0,0,0,49.09,0V200.9h167Z"
                transform="translate(0 -21.1)"
              />
            </svg> </router-link
          ><span>
            <router-link
              :to="{
                name: 'companyEvents',
                params: { companyId: currentCompanyId },
              }"
              >Events</router-link
            >
          </span>
        </div>
      </li>
      <li>
        <div>
          <router-link
            :to="{
              name: 'kyndPoints',
              params: { companyId: currentCompanyId },
            }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 985.01 1000"
              height="24"
              fill="#069BD7"
            >
              <title>Kyndhub_Kyndpoints_Icon</title>
              <polygon
                points="371.76 168.29 312.56 168.29 312.56 478.05 0 478.05 0 537.25 312.56 537.25 312.56 847.01 371.76 847.01 371.76 537.25 681.52 537.25 681.52 478.05 371.76 478.05 371.76 168.29"
              />
              <path
                d="M983.34,19.18a47.14,47.14,0,0,0-65.83-10L719.12,154.81l35,47.69L933.31,71v929H992.5V47.1A46.69,46.69,0,0,0,983.34,19.18Z"
                transform="translate(-7.5 -0.01)"
              />
            </svg>
          </router-link>
          <span>
            <router-link
              :to="{
                name: 'kyndPoints',
                params: { companyId: currentCompanyId },
              }"
            >
              Kynd Points
            </router-link>
          </span>
        </div>
      </li>
      <li v-if="companyHasStore()">
        <div>
          <router-link
            :to="{
              name: 'companyStore',
              params: { companyId: currentCompanyId },
            }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1000 881.93"
              height="24"
              fill="#069BD7"
            >
              <title>Kyndhub_Store_Icon</title>
              <path
                d="M839.82,158.34H160L0,526.55H116.35V926.3H542.4V526.55H774V941h37.69V526.55H1000ZM504.67,888.61H154.16v-362H504.67ZM542.4,488.86h-485L184.72,196.07H815.24l127,292.79Z"
                transform="translate(0 -59.03)"
              />
              <rect x="200.41" width="592.42" height="37.69" />
            </svg> </router-link
          ><span>
            <router-link
              :to="{
                name: 'companyStore',
                params: { companyId: currentCompanyId },
              }"
              >Store</router-link
            >
          </span>
        </div>
      </li>
      <li>
        <div>
          <router-link :to="{ name: 'challengesList' }">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1000 1000"
              height="24"
              fill="#069BD7"
            >
              <title>Kyndhub_Challenges_Icon</title>
              <path
                d="M403.05,1000h0C180.41,1000,0,819.43,0,596.79s180.56-403.09,403.21-403a403.12,403.12,0,0,1,204.27,55.64l-19,32.2C414.4,179.19,190.26,237.34,87.87,411.45S43.63,809.7,217.74,912.09,616,956.33,718.38,782.22a365.73,365.73,0,0,0,0-370.77l32.2-19c112.86,191.94,48.75,439-143.19,551.89A403.21,403.21,0,0,1,403.09,1000Z"
                transform="translate(0 0)"
              />
              <path
                d="M403.05,886.23c-159.81.35-289.64-128.92-290-288.73S242,307.86,401.79,307.51a289.68,289.68,0,0,1,76.48,10.12l-9.67,36.09c-134.42-36.22-272.76,43.38-309,177.8s43.38,272.77,177.81,309,272.76-43.38,309-177.8a252.05,252.05,0,0,0,0-131.19l36.1-9.66c41.65,154.19-49.58,312.95-203.77,354.61a289.09,289.09,0,0,1-75.68,10Z"
                transform="translate(0 0)"
              />
              <path
                d="M403,716.09a119.18,119.18,0,1,1,33.47-233.52L710.27,208.78l-6.39-48.1L864.52,0l15.89,119.59L1000,135.48,839.45,296l-48.1-6.39L517.56,563.44A119.14,119.14,0,0,1,403.13,716.05Zm0-201a81.92,81.92,0,1,0,75.71,50.63L474,554.18l303.94-304,48.1,6.39,94.22-94.23-73-9.71-9.71-73-94.23,94.22,6.48,48.14-304,304-11.51-4.76A82,82,0,0,0,403,515Z"
                transform="translate(0 0)"
              />
              <path d="M605.39,338.93" transform="translate(0 0)" />
            </svg>
          </router-link>
          <span>
            <router-link :to="{ name: 'challengesList' }">
              Challenges
            </router-link>
          </span>
        </div>
      </li>
      <li v-if="canManageCompanies() || canEditCompany(currentCompanyId)">
        <div @click="toggleOpenAdminHubs">
          <a>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 826.12 1000"
              height="24"
              fill="#069BD7"
            >
              <title>Kyndhub_Admin_Icon</title>
              <path
                d="M861.77,144.24a522.85,522.85,0,0,1-327-130.93,54.07,54.07,0,0,0-71.06,0A510.57,510.57,0,0,1,138,144.16a52.34,52.34,0,0,0-51.09,52.38V667.69a54.8,54.8,0,0,0,3.89,20.9,530.17,530.17,0,0,0,342.35,294.6c12.75,3.47,23.07,6.53,31.39,8.95a125.72,125.72,0,0,0,36.79,7.86,177.26,177.26,0,0,0,41.81-10.79c6.77-2.17,14.59-4.68,23.66-7.52h.37a522,522,0,0,0,342-294.35,60.49,60.49,0,0,0,3.89-20.91V196.62A52.38,52.38,0,0,0,861.77,144.24Zm9.07,524.08-.88,2A481.36,481.36,0,0,1,555.12,942l-54.34,16.47-54.35-14.84a489.79,489.79,0,0,1-315-271.74l-.88-2V186.68l9.95-.26A552.61,552.61,0,0,0,494,45L500.73,39,507.51,45A562.2,562.2,0,0,0,860.89,186.42l9.82.34Z"
                transform="translate(-86.94 0)"
              />
              <path
                d="M642.24,708.37,500.61,631.82,359.26,706.28,386,547.71,271.43,434.83l158.49-22.91L501,268.24l70.74,145.27,158.44,22.91L615.57,549.3ZM500.82,587.84l90,48.62-17-100.71,73.24-72L545.72,449.09l-45.07-92.6-44.9,91.05L354.46,462.17l73.24,72L410.64,635.37Z"
                transform="translate(-86.94 0)"
              />
            </svg> </a
          ><span>
            <a>Admin</a>
            <a>
              <svg
                viewBox="0 0 140 140"
                width="15"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path
                    d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"
                    fill="#069BD7"
                  />
                </g>
              </svg>
            </a>
          </span>
        </div>
        <ul :class="[leftMenuExpand && openedAdminHubs ? 'block' : 'hidden']">
          <li v-if="canManageCompanies() || canEditCompany(currentCompanyId)">
            <router-link
              v-if="canManageCompanies()"
              :to="{ name: 'adminCompanies' }"
              class="pl-29 w-full inline-block"
            >
              Hubs
            </router-link>
            <router-link
              v-if="!canManageCompanies() && canEditCompany(currentCompanyId)"
              :to="{
                name: 'adminCompaniesEdit',
                params: { companyId: currentCompanyId },
              }"
              class="pl-29 w-full inline-block"
            >
              Edit Hub
            </router-link>
          </li>
          <li>
            <router-link
              :to="{
                name: 'adminGroups',
                params: { companyId: currentCompanyId },
              }"
              class="pl-29 w-full inline-block"
            >
              Groups
            </router-link>
          </li>
          <li>
            <router-link
              :to="{
                name: 'adminUsers',
                params: { companyId: currentCompanyId },
              }"
              class="pl-29 w-full inline-block"
            >
              Users
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'adminWidgets' }"
              class="pl-29 w-full inline-block"
            >
              Widgets
            </router-link>
          </li>
          <li>
            <router-link
              :to="{
                name: 'reports',
                params: { companyId: currentCompanyId },
              }"
              class="pl-29 w-full inline-block"
            >
              My Giving Reports
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <div>
          <router-link
            :to="{
              name: 'productFeatures',
            }"
          >
            <svg
              id="Layer_1"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 1000 1000"
              style="enable-background:new 0 0 1000 1000;"
              xml:space="preserve"
              height="24"
            >
              <g transform="translate(0,-952.36218)">
                <path
                  fill="#069BD7"
                  d="M500.87,950.94c-12.85,0.4-23.01,11.04-22.8,23.9v68.01c-0.18,12.99,10.2,23.68,23.2,23.86
		c12.99,0.18,23.68-10.2,23.86-23.2c0-0.22,0-0.44,0-0.66v-68.01c0.21-12.99-10.16-23.7-23.15-23.91
		C501.6,950.92,501.23,950.93,500.87,950.94z M201.6,1086.97c-12.97,0.89-22.76,12.11-21.87,25.08c0.4,5.83,2.95,11.31,7.17,15.36
		l44.12,45.22c9.04,9.34,23.93,9.59,33.28,0.56c9.34-9.04,9.59-23.93,0.56-33.28l-44.12-45.59c-4.4-4.65-10.51-7.31-16.92-7.35
		C203.07,1086.93,202.34,1086.93,201.6,1086.97z M798.65,1086.97c-6.14,0.25-11.94,2.89-16.16,7.35l-44.12,45.59
		c-9.24,9.14-9.32,24.04-0.18,33.28c9.14,9.24,24.04,9.32,33.28,0.18c0.24-0.24,0.48-0.49,0.71-0.74l44.12-45.22
		c9.36-9.02,9.64-23.91,0.62-33.27C812.16,1089.2,805.49,1086.58,798.65,1086.97z M501.59,1132.55
		c-136.39,0-266.16,114.24-266.16,273.16c0,100.26,36.79,159.81,70.59,205.51c32.98,44.62,60.49,74.64,61.76,130.51
		c-0.12,1.35-0.12,2.7,0,4.04c-0.05,0.86-0.05,1.72,0,2.57v133.45c0,38.61,31.35,69.12,67.65,69.12h132.35
		c36.28,0,67.65-30.52,67.65-69.12v-136.03c0-58.54,27.98-88.85,61.76-134.56c33.78-45.71,70.59-105.25,70.59-205.51
		C767.78,1246.79,638,1132.55,501.59,1132.55L501.59,1132.55z M501.59,1179.61c110.13,0,219.13,92.8,219.13,226.1
		c0,89.31-29.4,133.42-61.76,177.2c-28.8,38.94-62.39,78.82-69.49,139.34h-176.1c-7.04-60.51-40.32-100.39-69.1-139.34
		c-32.39-43.79-61.76-87.89-61.76-177.2C282.49,1272.42,391.5,1179.61,501.59,1179.61L501.59,1179.61z M837.99,1391.74
		c-12.98,0.83-22.83,12.03-22,25.02c0.8,12.52,11.28,22.22,23.83,22.04h80.89c12.99,0.17,23.67-10.23,23.84-23.22
		c0.17-13-10.23-23.67-23.22-23.84c-0.2,0-0.41,0-0.61,0h-80.89C839.21,1391.72,838.6,1391.72,837.99,1391.74z M79.92,1393.58
		c-12.99,0.71-22.95,11.82-22.24,24.82c0.71,12.99,11.82,22.95,24.82,22.24l0,0h66.16c12.99,0.17,23.67-10.23,23.84-23.22
		c0.17-13-10.23-23.67-23.22-23.84c-0.2,0-0.41,0-0.61,0H82.49C81.64,1393.53,80.78,1393.53,79.92,1393.58z M261.9,1636.59
		c-0.99,0.06-1.97,0.18-2.94,0.36c-5.37,0.77-10.3,3.36-13.98,7.35l-56.61,58.09c-9.24,9.14-9.32,24.04-0.18,33.28
		s24.04,9.32,33.28,0.18c0.24-0.24,0.48-0.49,0.71-0.74l56.99-58.09c9.35-9.03,9.61-23.92,0.58-33.27
		C275.1,1638.93,268.6,1636.33,261.9,1636.59L261.9,1636.59z M738.37,1636.96c-12.93,1.26-22.4,12.77-21.14,25.7
		c0.53,5.43,2.93,10.51,6.8,14.37l56.98,58.09c9.04,9.34,23.93,9.59,33.28,0.56c9.34-9.04,9.59-23.94,0.56-33.28l-57.36-58.09
		C752.56,1639.07,745.52,1636.36,738.37,1636.96z M414.84,1769.31h173.53v112.5c0,13.51-10.32,22.06-20.59,22.06H435.43
		c-10.27,0-20.59-8.55-20.59-22.06V1769.31z"
                />
              </g>
            </svg> </router-link
          ><span>
            <router-link
              :to="{
                name: 'productFeatures',
              }"
              >Product Features</router-link
            >
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>
